<template>
  <Button
    :block="block"
    :danger="danger"
    :disabled="disabled"
    :ghost="ghost"
    :href="href"
    :htmlType="htmlType"
    :loading="btnLoading || loading"
    :shape="shape"
    :size="size"
    :target="target"
    :type="type"
    @click="handleClick"
    style="display: inline-flex; align-items: center"
  >
    <smart-icon :icon="icon" v-if="icon" class="button-icon"></smart-icon>
    <slot></slot>
  </Button>
</template>

<script lang="tsx" setup name="SmartButton">
import { Button, message } from 'ant-design-vue'
import SmartIcon from '../smart-icon/index.vue'
import {inject, ref} from 'vue'

const lang = inject('lang')
const props = defineProps([
  'block',
  'danger',
  'disabled',
  'ghost',
  'href',
  'htmlType',
  'icon',
  'loading',
  'shape',
  'size',
  'target',
  'type',
  'click',
  'clickOnLoading'
])

const btnLoading = ref(false)
const emit = defineEmits(['click'])

const closeLoading = () => {
  btnLoading.value = false
}
const handleClick = (...arg: any) => {
  if (props.disabled) {
    // 当前逻辑不会被出发 antd 有比较好的处理 当前逻辑兜底
    message.warning(lang('按钮已禁用'))
    return
  }
  if (props.clickOnLoading && typeof props.clickOnLoading === 'function') {
    btnLoading.value = true
    props.clickOnLoading(closeLoading)
  }
  if (props.click && typeof props.click === 'function') {
    props.click(...arg)
    return
  }
  emit('click', ...arg)
}
</script>
<style lang="less" scoped>
.button-icon {
  margin-right: 5px;
}
</style>
